export default __webpack_public_path__ + "static/media/MoneyBarn_Declaration.13b9492d.pdf";